// extracted by mini-css-extract-plugin
export default {"rodape_configuracoes":"Rodape_rodape_configuracoes__X1vkE","botao":"Rodape_botao__Ofe9a"};